// extracted by mini-css-extract-plugin
export var boxItems = "_77-1";
export var boxItemsLg = "_77-2";
export var button = "_77-7";
export var buttonLg = "_77-8";
export var filterGroupBox = "_77-0";
export var icon = "_77-3";
export var iconSecondary = "_77-6";
export var iconWrapper = "_77-4";
export var iconWrapperLg = "_77-5";